import React from "react";
import { Col, Row } from "react-bootstrap";
import * as CgIcons from "react-icons/si";
import * as DiIcons from "react-icons/di"; 
import techData from "../../Tech.json";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techData.Techs.map((tech) => {
        const IconComponent = DiIcons[tech.icon] || CgIcons[tech.icon]; 
        return (
          <Col key={tech.id} xs={4} md={2} className="tech-icons">
            {IconComponent && <IconComponent />}
          </Col>
        );
      })}
    </Row>
  );
}

export default Techstack;
